<script lang="ts">
  import { AnchorInline } from '$lib/components/anchor';
  import { TableClientSide } from '$lib/components/table';
  import { TextCopy, TextInfo } from '$lib/components/text';
  import { AppPath } from '$lib/features/app';
  import type { CompanyOfficeDto } from '$lib/features/bff/sdk';
  import { formatDate, formatTaxId } from '$lib/features/format';
  import { OfficeChipType } from '$lib/features/office';

  /** Required */
  export let offices: CompanyOfficeDto[];
</script>

<TableClientSide
  width="max-w-[590px]"
  limit={offices.length > 10 ? 10 : offices.length}
  searchable={offices.length > 10}
  pageable={offices.length > 10}
  searchNested
  headers={['Tipo', 'CNPJ', 'Situação', 'Abertura']}
  headerWidths={['min-w-20', 'min-w-52', 'min-w-44', 'w-full ']}
  searchPlaceholder="Refinar CNPJ, nome ou situação"
  placeholderHeight="h-10"
  dataset={offices.sort((a, b) => Number(a.taxId) - Number(b.taxId))}
  let:records
>
  {#each records as o}
    <tr>
      <!-- Type -->
      <td class="!text-center">
        <OfficeChipType head={o.head} />
      </td>

      <!-- Tax ID -->
      <td class="font-medium">
        <AnchorInline label={formatTaxId(o.taxId)} href={`${AppPath.OFFICE}/${o.taxId}`} />

        <br />

        <div class="max-w-40 overflow-hidden">
          <TextCopy
            font="text-surface-600-300-token truncate text-nowrap text-xs"
            value={o.alias?.length > 20
              ? `${o.alias.slice(0, 24)}...`
              : o.alias || (o.head ? 'Matriz' : `Filial ${o.taxId.slice(8, 12)}`)}
            onCopy={() => o.alias || (o.head ? 'Matriz' : `Filial ${o.taxId.slice(8, 12)}`)}
          />
        </div>
      </td>

      <!-- Status -->
      <td class="font-medium">
        <TextInfo
          display="gap-2"
          icon={o.special?.id ? 'shield-alert' : o.status.id === 2 ? 'shield-check' : 'shield-x'}
          iconWidth="w-[20px]"
          iconColor={o.special?.id
            ? 'text-warning-700-200-token'
            : o.status.id === 2
              ? 'text-success-500-400-token'
              : 'text-error-500-400-token'}
          label={o.special?.id ? 'Ativa Especial' : o.status.text}
        >
          <span class="text-surface-600-300-token text-xs">
            Desde <TextCopy value={formatDate(o.special?.id ? o.specialDate : o.statusDate)} />
          </span>
        </TextInfo>
      </td>

      <!-- Founded -->
      <td class="!text-center">
        <TextCopy value={formatDate(o.founded)} />
      </td>
    </tr>
  {/each}
</TableClientSide>
